import { isSingleLineListView } from "owa-mail-layout";
import { PreviewLinesOption } from "../store/schema/PreviewLinesOption";

export default function getFallbackPreviewLinesToShow(): number {
    return isSingleLineListView() ? PreviewLinesOption.Inline : PreviewLinesOption.OneLine;
}
